import { SxProps, TextField, Typography } from '@mui/material';
import React from 'react';
import InfoIcon from '@mui/icons-material/Info';
import SearchIcon from '@mui/icons-material/Search';
interface BkTextFieldProps {
  label?: string;
  value: string;
  name: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, id?: string) => void;
  error: string | undefined;
  width?: string;
  placeholder?: string;
  disabled?: boolean;
  heading?: string;
  customStyles?: SxProps;
  hasCustomSearchIcon?: boolean;
  autoComplete?: string;
  helperText?: string;
  hideHelperText?: boolean;
  minRows?: string | number | undefined;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
}

const BkTextField: React.FC<BkTextFieldProps> = ({
  label,
  value,
  name,
  error,
  width,
  placeholder,
  disabled,
  heading,
  onChange,
  customStyles,
  hasCustomSearchIcon,
  autoComplete,
  helperText,
  hideHelperText,
  minRows,
  inputProps,
}) => {
  return (
    <>
      {heading !== undefined && (
        <Typography sx={{ marginBottom: '0.625rem' }}>{heading}</Typography>
      )}
      <TextField
        sx={{
          width: width ? width : '100%',
          '& .MuiInputBase-input': {
            padding: '0.625rem',
          },
          ...customStyles,
        }}
        fullWidth={width !== undefined ? false : true}
        name={name}
        multiline={minRows ? true : undefined}
        minRows={minRows}
        placeholder={placeholder}
        onChange={onChange}
        inputProps={inputProps}
        label={label !== '' ? label : undefined}
        value={value}
        disabled={disabled}
        autoComplete={autoComplete}
        error={error !== undefined && error !== ''}
        helperText={
          helperText && (error == undefined || error == '')
            ? helperText
            : !hideHelperText && error !== undefined && error !== ''
              ? error
              : ''
        }
        InputLabelProps={{ shrink: true }}
        InputProps={{
          endAdornment:
            !hideHelperText && error !== undefined && error !== '' ? (
              <InfoIcon color='error' />
            ) : hasCustomSearchIcon ? (
              <SearchIcon sx={{ color: '#6D7176' }} />
            ) : (
              <></>
            ),
        }}
      />
    </>
  );
};

export default BkTextField;
